<template>
    <div
        class="modal fade"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        :aria-label="title"
        ref="modalFormElement">
        <div
            class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            :style="{maxWidth: `${width}px`}">
            <form
                class="modal-content"
                @submit.prevent="submit">
                <div class="modal-header">
                    <h4 class="modal-title">{{ title }}</h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <div class="button-wrapper">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">
                            Cancel
                        </button>
                        <button
                            class="btn btn-primary"
                            type="submit">
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script setup lang="ts">
import {onMounted, ref, watch} from "vue";
import {Modal} from "bootstrap";

const model = defineModel({type: Boolean});

const props = withDefaults(
    defineProps<{
        title?: string;
        width: number;
    }>(),
    {
        width: 750,
    }
);

const modalFormElement = ref<HTMLElement>();
let modelObject: Modal;

const emit = defineEmits(["submit"]);

onMounted(() => {
    modelObject = new Modal(modalFormElement.value!);

    modalFormElement.value!.addEventListener("hidden.bs.modal", (event) => {
        model.value = false;
    });
});

const submit = function () {
    emit("submit");
};

function _show() {
    modelObject.show();
    model.value = true;
}

function _hide() {
    modelObject.hide();
    model.value = false;
}

watch(
    () => model.value,
    (showModal, prevShowModal) => {
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);
</script>
<style lang="scss">
.button-wrapper {
    display: inline grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: 0.5rem;
}
</style>
